<template>
  <page-outline :title="$t('settings.setting_label')" icon="icon-gearwheels" colWidth="6">

    <template slot="pageContent">
      <!--<b-row>
        <b-col>
          <div class="contactButtonContainer mt-0 mb-4"  v-if="services.length > 1">
            <b-row class="no-gutters justify-content-start">
              <b-col sm="4" class="pilotageTabController" v-for="service in services" :key="service.id">
                <f7-link class="pilotageLink tabActive" v-if="currentTab === service.name" tab-link=".membersTab1" @click="changeCurrentTab(service.id)" active>{{ $t('servicesNames.'+service.name) }}</f7-link>
                <f7-link class="pilotageLink tabUnactive" v-else tab-link=".membersTab1" @click="changeCurrentTab(service.id)" active>{{ $t('servicesNames.'+service.name) }}</f7-link>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>-->
      <div class="col-md-12">
        <dp-settings v-if="currentTab === '6'" :settings="DPSettingsData"></dp-settings>
        <rtp-settings v-else-if="currentTab === '1'" :settings="RTPSettingsData"></rtp-settings>
        <ml-settings v-else-if="currentTab === '2'" :settings="MLSettingsData"></ml-settings>
        <ds-settings v-else-if="currentTab === '3'" :settings="DSSettingsData"></ds-settings>
        <mp-settings v-else-if="currentTab === '8'" :settings="MPSettingsData"></mp-settings>
      </div>
      <b-row v-if="canEditSettings()">
        <b-col cols="12" md="6" offset-md="3" class="form-group">
          <b-button variant="primary" size="lg"
            @click="changeApplicationSettings">
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
    <template slot="footerButtons">
    </template>
  </page-outline>
</template>


<script>
import PageOutline from '@/components/common/PageOutline.vue'
import DPSettings from './SettingsList/DirectPaymentSettings.vue'
import RTPSettings from './SettingsList/RequestToPaySettings.vue'
import MLSettings from './SettingsList/DirectDebitSettings.vue'
import DSSettings from './SettingsList/DocumentServiceSettings.vue'
import MPSettings from './SettingsList/MarketplaceSettings.vue'
import {errorMessageAlert} from '@/helpers/alert'
import services from '@/helpers/services'
// import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'dp-settings': DPSettings,
    'rtp-settings': RTPSettings,
    'ml-settings': MLSettings,
    'ds-settings': DSSettings,
    'mp-settings': MPSettings,
    'page-outline': PageOutline
  },
  data () {
    return {
      idSettingsApplication: '',
      defaultNegotiationAllowed: false,
      negotiationActivated: true,
      defaultInstallmentNumber: 1,
      ocrActivation: false,
      validationThreshold: 0,
      validationThreshold: 0,
      maxAmount: '',
      rtpsTimeBeforeExpiration: '',
      isToGenerateXML: false,
      sendPaymentRequestEmail: false,
      pain001: false,
      pacs008: false,
      auto_accept_document: false,
      accept_document: false,
      decision_creancier: false,
      emailForRcv: true,
      auto_accept_payment: false,
      notif_mail_rcv_doc: false,
      email_notif_rcv_doc: false,
      max_amount: 0,
      paymentMethod: '',
      currentTab: '1',
      DPSettingsData: {},
      RTPSettingsData: {},
      MLSettingsData: {},
      DSSettingsData: {},
      MPSettingsData: {},
      services: {}
    }
  },
  created () {
    this.services = this.$engine.services.get()
    if(this.services && this.services.length) {
      this.currentTab = this.services[0].id
    }
    this.RTPSettingsData = {
      defaultModificationInstallmentsAllowed: '0',
      defaultNegotiationAllowed: '0',
      enableInstallmentRules: '0',
      idSettingsApplication: '',
      isToGenerateXML: '0',
      ocrActivation: '0',
      paymentMethod: '',
      sendPaymentRequestEmail: '0',
      validationThreshold: '0',
      rtpsTimeBeforeExpiration: '',
      SRTPmaxAmount: '',
      HRTPmaxAmount: ''
    }
    this.DPSettingsData = {
      pain001: '0',
      pacs008: '0',
      decision_creancier: '0',
      ocrActivation: '0',
      emailForRcv: '1',
      auto_accept_payment: '0',
      max_amount: 0,
      idSettingsApplication: ''
    }
    this.MLSettingsData = {
      sendPaymentRequestEmail: '0',
      ocrActivation: '0',
      isToGenerateXML: '0',
      validationThreshold: 0,
      paymentMethod: '',
      enableInstallmentRules: '0',
      defaultNegotiationAllowed: '0',
      defaultModificationInstallmentsAllowed: '0'
    }
    this.DSSettingsData = {
      accept_document: '0',
      auto_accept_documents: '0',
      daysBeforeReminderAcceptation: '30',
      daysBeforeReminderPayment: '30',
      daysBetweenReminderAcceptation: '30',
      daysBetweenReminderPayment: '30',
      defaultNegotiationAllowed: '0',
      defaultReminderAcceptationActive: '0',
      defaultReminderPaymentActive: '0',
      email_notif_rcv_doc: '0',
      idSettingsApplication: '',
      isToGenerateXML: '0',
      maxNumberReminderAcceptation: '0',
      maxNumberReminderPayment: '0',
      ocrActivation: '0',
      paymentMethod: '',
      sendPaymentRequestEmail: '0',
      validationThreshold: 0
    }
    this.MPSettingsData = {
      bic_real: '',
      bic_technical: '',
      freq_statement: '0',
      iban_real: '',
      iban_technical: '',
      key_bl: '',
      key_mac: '',
      mid: '',
      payment_threshold_minus: '0',
      payment_threshold_plus: '0',
      sys_comission: '0',
      viban_liberation_time: '0',
      viban_mode: '1'
    }
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
  },
  mounted () {
    if (!this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.$$('.accordionForm').addClass('accordion-item-expanded')
      this.$$('.formChevron').transform('rotate(90deg)')
    }
    this.DPSettingsData = this.$engine.settings.get(services.DIRECTPAYMENTS)
    this.RTPSettingsData = this.$engine.settings.get(services.PAYMENTS)
    if (!this.RTPSettingsData.SRTPmaxAmount) {
      this.RTPSettingsData.SRTPmaxAmount = this.$engine.settings.getGlobal()['SRTP-RTPSPMaxAmount']
    }
    if (!this.RTPSettingsData.HRTPmaxAmount) {
      this.RTPSettingsData.HRTPmaxAmount = this.$engine.settings.getGlobal()['HRTP-RTPSPMaxAmount']
    }
    if (!this.RTPSettingsData.rtpsTimeBeforeExpiration) {
      this.RTPSettingsData.rtpsTimeBeforeExpiration = this.$engine.settings.getGlobal().RTPSPTimeBeforeExpiration
    }
    this.MLSettingsData = this.$engine.settings.get(services.DIRECTDEBIT)
    this.DSSettingsData = this.$engine.settings.get(services.DOCUMENTSERVICE)
    this.MPSettingsData = this.$engine.settings.get(services.SUPPLIERS)
  },
  methods: {
    canEditSettings () {
      return this.$engine.rights.rightIs('settings_edit', true)
    },
    changeCurrentTab (role) {
      this.currentTab = role
    },
    changeApplicationSettings () {
      let that = this
      let serviceSettings = {}
      let serviceName = ''

      if (this.currentTab === '6') {
        serviceSettings = this.DPSettingsData
        serviceName = 'directPayments'
      } else if (this.currentTab === '1') {
        serviceSettings = this.RTPSettingsData
        serviceName = 'payments'
        if(!this.RTPSettingsData.rtpsTimeBeforeExpiration) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_time_before_expiration')}))
          return
        }
        if(!this.RTPSettingsData.SRTPmaxAmount) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_max_amnt_lng')}))
          return
        }
        if(!this.RTPSettingsData.HRTPmaxAmount) {
          this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_max_amnt_lng')}))
          return
        }
      } else if (this.currentTab === '2') {
        serviceSettings = this.MLSettingsData
        serviceName = 'directDebit'
      } else if (this.currentTab === '3') {
        serviceSettings = this.DSSettingsData
        serviceName = 'documentService'
      } else if (this.currentTab === '8') {
        serviceSettings = this.MPSettingsData
        serviceName = 'seller'
      }

      this.$engine.settings.update(serviceSettings, serviceName)
      .then(() => {
        that.$f7.modal({
          title: that.$t('settings.applctn_sttngs_mdfd'),
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
        }, 2000)
      })
      .catch(err => {
        errorMessageAlert(err, this)
      })
    }
  }
}
</script>
<style scoped>
.subOption {
  font-size: 14px;
}
.subOption input::-webkit-input-placeholder {
  font-size: 14px;
}


.label-switch {
  float: right;
}

.no-bullets {
    list-style-type: none;
}
.mt-2 {
  width: 100%;
}
.inputFileButton {
  float: left;
}
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}

.button-setting {
  width: 80px;
}
ul {
  margin-left: -35px;
}
</style>
